import { Injectable, NgModule } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmbedParametersViewModel } from '../models/EmbedParametersViewModel';
import { BaseService } from './BaseService';
import { BaseAddressInterceptor } from '../interceptors/BaseAddressInterceptor';
import { map, filter } from 'rxjs/operators';
import { Effect } from '@ngrx/effects';

@Injectable()

class PowerBIServiceApi extends BaseService {
    constructor(http: HttpClient, private baseAddressInterceptor: BaseAddressInterceptor) {
        super(http);
    }

    /**
      * @param params The `PowerBIService.PowerBI_GetEmbedInfoParams` containing the following parameters:
      *
      * - `workspaceId`:
      *
      * - `reportId`:
      *
      * @return Success
    */
    @Effect()
    PowerBI_GetEmbedInfoResponse(params: PowerBIServiceApi.PowerBI_GetEmbedInfoParams): Observable<HttpResponse<EmbedParametersViewModel>> {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body: any = null;
        if (params.workspaceId != null) __params = __params.set('workspaceId', params.workspaceId.toString());
        if (params.reportId != null) __params = __params.set('reportId', params.reportId.toString());

        let req = new HttpRequest<any>(
            'GET',
            this.baseAddressInterceptor.getApiUrl('/api/SubmissionModule/Job/GetEmbedInfo'),
            __body,
            {
                headers: __headers,
                params: __params,
                responseType: 'json'
            });

        return this.http.request<any>(req).pipe(
            filter(_r => _r instanceof HttpResponse),
            map(_r => {
                let _resp = _r as HttpResponse<any>;
                let _body: EmbedParametersViewModel = null;
                _body = _resp.body as EmbedParametersViewModel;
                return _resp.clone({ body: _body }) as HttpResponse<EmbedParametersViewModel>;
            })
        );
    }

    /**
       * @param params The `PowerBIService.PowerBI_GetEmbedInfoParams` containing the following parameters:
       *
       * - `workspaceId`:
       *
       * - `reportId`:
       *
       * @return Success
    */
    @Effect()
    PowerBI_GetEmbedInfo(params: PowerBIServiceApi.PowerBI_GetEmbedInfoParams): Observable<EmbedParametersViewModel> {
        return this.PowerBI_GetEmbedInfoResponse(params).pipe(
            map(_r => _r.body)
        );
    }

    /**
      * @param params The `PowerBIService.PowerBI_GetEmbedInfoByPathNameParams` containing the following parameters:
      *
      * - `workspaceKey`:
      *
      * - `pathName`:
      *
      * @return Success
    */
    @Effect()
    PowerBI_GetEmbedInfoByPathNameResponse(params: PowerBIServiceApi.PowerBI_GetEmbedInfoByPathNameParams): Observable<HttpResponse<EmbedParametersViewModel>> {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body: any = null;
        if (params.workspaceKey != null) __params = __params.set('workspaceKey', params.workspaceKey.toString());
        if (params.pathName != null) __params = __params.set('pathName', params.pathName.toString());
        let req = new HttpRequest<any>(
            'GET',
            this.baseAddressInterceptor.getApiUrl('/api/SubmissionModule/Job/GetEmbedInfoByPathName'),
            __body,
            {
                headers: __headers,
                params: __params,
                responseType: 'json'
            });

        return this.http.request<any>(req).pipe(
            filter(_r => _r instanceof HttpResponse),
            map(_r => {
                let _resp = _r as HttpResponse<any>;
                let _body: EmbedParametersViewModel = null;
                _body = _resp.body as EmbedParametersViewModel;
                return _resp.clone({ body: _body }) as HttpResponse<EmbedParametersViewModel>;
            })
        );
    }

    /**
      * @param params The `PowerBIService.PowerBI_GetEmbedInfoByPathNameParams` containing the following parameters:
      *
      * - `workspaceKey`:
      *
      * - `pathName`:
      *
      * @return Success
    */
    @Effect()
    PowerBI_GetEmbedInfoByPathName(params: PowerBIServiceApi.PowerBI_GetEmbedInfoByPathNameParams): Observable<EmbedParametersViewModel> {
        return this.PowerBI_GetEmbedInfoByPathNameResponse(params).pipe(
            map(_r => _r.body)
        );
    }

    /**
      * @param params The `PowerBIService.PowerBI_GetEmbedInfoForCreateParams` containing the following parameters:
      *
      * - `workspaceId`:
      *
      * - `datasetId`:
      *
      * @return Success
    */
    @Effect()
    PowerBI_GetEmbedInfoForCreateResponse(params: PowerBIServiceApi.PowerBI_GetEmbedInfoForCreateParams): Observable<HttpResponse<EmbedParametersViewModel>> {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body: any = null;
        if (params.workspaceId != null) __params = __params.set('workspaceId', params.workspaceId.toString());
        if (params.datasetId != null) __params = __params.set('datasetId', params.datasetId.toString());
        let req = new HttpRequest<any>(
            'GET',
            this.baseAddressInterceptor.getApiUrl('/api/SubmissionModule/Job/GetEmbedInfoForCreate'),
            __body,
            {
                headers: __headers,
                params: __params,
                responseType: 'json'
            });

        return this.http.request<any>(req).pipe(
            filter(_r => _r instanceof HttpResponse),
            map(_r => {
                let _resp = _r as HttpResponse<any>;
                let _body: EmbedParametersViewModel = null;
                _body = _resp.body as EmbedParametersViewModel;
                return _resp.clone({ body: _body }) as HttpResponse<EmbedParametersViewModel>;
            })
        );
    }

    /**
     * @param params The `PowerBIService.PowerBI_GetEmbedInfoForCreateParams` containing the following parameters:
     *
     * - `workspaceId`:
     *
     * - `datasetId`:
     *
     * @return Success
     */
    @Effect()
    PowerBI_GetEmbedInfoForCreate(params: PowerBIServiceApi.PowerBI_GetEmbedInfoForCreateParams): Observable<EmbedParametersViewModel> {
        return this.PowerBI_GetEmbedInfoForCreateResponse(params).pipe(
            map(_r => _r.body)
        );
    }
}


module PowerBIServiceApi {
    /**
       * Parameters for PowerBI_GetEmbedInfo
    */
    export interface PowerBI_GetEmbedInfoParams {
        workspaceId?: string;
        reportId?: string;
    }

    /**
      * Parameters for PowerBI_GetEmbedInfoByPathName
    */
    export interface PowerBI_GetEmbedInfoByPathNameParams {
        workspaceKey?: string;
        pathName?: string;
    }

    /**
      * Parameters for PowerBI_GetEmbedInfoForCreate
    */
    export interface PowerBI_GetEmbedInfoForCreateParams {
        workspaceId?: string;
        datasetId?: string;
    }
}

export { PowerBIServiceApi }


// WEBPACK FOOTER //
// ./src/app/core/services/PowerBIService.ts